import React from "react";
import { Redirect } from "react-router-dom";
import { inject, observer } from "mobx-react";


@inject('searchPageArtworksStore', 'navigatorStore')
@observer
export default class categoryCards extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            clickedOnCategory: false,
            categoryKW: "",
            categoryName: ""
        }
    }

    handleCategoryClick(kw, name, type) {

        /*    if (!localStorage.hasOwnProperty("userData")) {
               this.props.navigatorStore.openSignInModal();
           }
   
           else { */
        this.setState({
            clickedOnCategory: true,
            categoryKW: kw,
            categoryName: name,
            type : type

        })
        this.props.searchPageArtworksStore.getAllArtworks({ search: name })
        // }

    }
    render() {

        if (this.state.clickedOnCategory) {
            if (this.props.artistCategory) {
                return(
                    <Redirect push to={{ pathname: `/allartists/${this.state.categoryKW}/${this.state.categoryName}/${true}` }} />
                )
            }
            if(this.state.type=="search"){
                return(
                    <Redirect push to={`/searchpage_artworks/category_/${this.state.categoryKW}`} />
                )
            }
            return (

                <Redirect push to={{ pathname: `/categorypoducts/search=${this.state.categoryKW}/${this.state.categoryName}` }} />
            )
        }

        return (
            <CategoryCardsHolder
                colored={this.props.colored}
                categoriesDetails={this.props.categoriesDetails}
                handleCategoryClick={this.handleCategoryClick.bind(this)} />
        )
    }
}


const CategoryCardsHolder = (props) => {
    let { categoriesDetails, handleCategoryClick } = props
    return (
        categoriesDetails.map(
            (el, elIndex) => (
                <div className="col-12 col-sm-4 col-md-4 col-lg-4 col-xl-3 cat-block" style={{
                    backgroundColor: (props.colored) ? "#F6F6F6" : "#ffff",
                    marginTop: (window.location.href.includes("categorylist")) ? "5px" : "0px"
                }}>
                    <div className="category-placeholder height-180" style={{ backgroundColor: (props.colored) ? "#F6F6F6" : "#ffff" }}
                        onClick={() => handleCategoryClick(el.value, el.name, el.type)} key={elIndex}>
                        <a target="_blank" className="bg_overlay" >
                            <div className="image">
                                <div className="child">
                                    <img src={el.path} className="category-image height-180" />
                                </div>
                            </div>
                            <div className="category-title mt-25">{el.name}</div>
                        </a>
                    </div>
                </div>

            )
        )
    )
}


// WEBPACK FOOTER //
// ./src/components/cardHolders/categoriesCard.js